import React, { useRef, useState, useEffect } from 'react';

import { isEqual } from "lodash";

import { makeStyles } from '@mui/styles';
import CommonStyles from './CommonStyles';

import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';

import Switcher from './Switcher';
import TrplSelect from './TrplControls/TrplSelect';
import Search from './Search';
import Node from './Node';

import AceEditor from 'react-ace';

import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/mode-golang";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/ext-searchbox";

// import 'brace'; import 'brace/ext/searchbox';
// import 'ace-builds/src-noconflict/theme-monokai';

// import 'brace/mode/golang';
// import 'brace/snippets/golang';


// const customTheme = "custom-monokai";

// ace.define(customTheme, ["require", "exports", "module", "ace/lib/dom"], function(
//   require,
//   exports,
//   module
// ) {
//   exports.isDark = true;
//   exports.cssClass = "ace-custom-monokai";
//   exports.cssText = `
//       .ace-custom-monokai .ace_null {
//           color: gray;
//       }
//   `;

//   var dom = require("../lib/dom");
//   dom.importCssString(exports.cssText, exports.cssClass);
// });

const useStyles = makeStyles({
  ...CommonStyles,
  container: {
    width: '-webkit-fill-available',
    color: '#4E4C4C',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    // '& .highlighted-line': {
    //   backgroundColor: '#ff00004f',
    // },
    // '& .highlighted-line-no': {
    //   backgroundColor: '#292C25',
    // },
    '& .ace_scroller': {
      bottom: '1px !important',
      right: '1px !important',
    },
    '& .ace_scrollbar': {
      opacity: 0.5,
      '&:hover': {
        opacity: 0.8,
      },
    },
    '& .ace_scrollbar::-webkit-scrollbar': {
      height: '7px',
      width: '7px',
    },
    '& .ace_scrollbar::-webkit-scrollbar-thumb': {
      backgroundColor: '#C4C4C4',
      borderRadius: '10px',
    },
  },
  blockName: {
    whiteSpace:'nowrap',
    color: '#4C4C4C',
    width: '80px',
  },
});

// const customTheme = "ace/theme/custom-monokai";
// ace.acequire(customTheme, (t) => {
//   const rules = t.$rules;
//   rules.null = [
//     {
//       token: "constant.language.null",
//       regex: "\\b(null)\\b",
//       // change the color to red
//       // You can change the color code to your preference
//       // For example: "#ff0000" for pure red
//       // For more options, see: https://github.com/ajaxorg/ace/blob/master/lib/ace/theme/monokai.css
//       css: "color: #f92672",
//     },
//   ];
// });

const Macros =
  ({
    macro,
    nodes,
    showArgs,
    showCode,
    oldMacro,
    showAsync,
    searchValue,
    showScriptType,
    showReturnType,
    nonResizable,
    fullWidth,
    editable,
    returnType,
    functionVal,
    scriptType,
    onArgRemove,
    macro_types,
    borderColor,
    funcArguments,
    addNodeToState,
    linesNumberToPx,
    setFunctionPerfValues,
    addFunctionPerfArguments,
  }) => {
    const [macroEdited, setMacroEdited] = useState(false);
    const [resized, setResized] = useState(false);

    const classes = useStyles();
    const aceEditorRef = useRef(null);

    useEffect(() => {
      if (editable) {
        if (isEqual(functionVal, oldMacro)) setMacroEdited(false);
        else setMacroEdited(true);
      }
    }, [oldMacro, editable, functionVal]);

    const removeParams = (obj) => {
      const { code, script_type, return_type, args, async, ...rest } = obj;
      return rest;
    };

    // useEffect(() => {
    //   console.log(aceEditorRef);
    //   if (aceEditorRef.current && aceEditorRef.current !== null) {
    //     console.log(aceEditorRef);

    //     var rules = aceEditorRef.current.editor.session.$mode.$highlightRules.getRules();
    //     for (var stateName in rules) {
    //       if (Object.prototype.hasOwnProperty.call(rules, stateName)) {
    //           rules[stateName].unshift(
    //               {
    //                 token: 'null',
    //                 regex: 'FLIGHTINFO|\\${p:.+}|\\${p\\?:.+}'
    //               },
    //               {
    //                 token : "comment",
    //                 regex : /^~.*$/
    //               },
    //               {
    //                 token : "variable",
    //                 regex : /:.*$/
    //               },
    //               {
    //                 token : "keyword",
    //                 regex : /(?:set|add|show|ifg)\b/,
    //                 caseInsensitive: true
    //               },
    //               // {
    //               //   token: "constant.language",
    //               //   regex: /\bnull\b/,
    //               //   caseInsensitive: true
    //               // },
    //               {
    //                 token : "constant.numeric",
    //                 regex : /[0-9]+\b/,
    //               }
    
    //         );
    //       }
    //     }
    //     // force recreation of tokenizer
    //     // aceEditorRef.current.editor.session.$mode.$tokenizer = null;
    //     aceEditorRef.current.editor.session.bgTokenizer.setTokenizer(aceEditorRef.current.editor.session.$mode.getTokenizer());
    //     // // force re-highlight whole document
    //     aceEditorRef.current.editor.session.bgTokenizer.start(0);

    //   }
    // }, [aceEditorRef.current]);

    useEffect(() => {
      if (searchValue) {
        const editorInstance = aceEditorRef.current.editor;
        const searchOptions = {
          needle: searchValue,
          wrap: true,
          caseSensitive: false,
          regExp: false,
        };
        const range = editorInstance.find(searchOptions);
        if (range) {
          editorInstance.selection.setSelectionRange(range);
        }
      }
    }, [searchValue]);

    const onlyFunction = showCode && !showArgs && !showScriptType && !showReturnType;

    const macroMetaProps = macro && removeParams(macro);

    return (
      <div style={{ outline: '1px solid #EEECF8', width: '-webkit-fill-available', height: nonResizable ? '100%' : 'fit-content' }}>
        {macro && Object.values(macroMetaProps).length ?
          <div className={`${classes.justifyEnd}`} style={{ color: '#878787', fontSize: 10, padding: '5px 5px 1px 5px' }}>
            {Object.keys(macroMetaProps).map((key, index) => {
              return (
                <span key={index} className={ classes.mr10 }>{`${key}: ${macroMetaProps[key]}`}</span>
              )
            })}
          </div>
        : null}

        {showAsync ?
          <div className={`${classes.container} ${classes.p5}`}>
            <div className={classes.blockName}>Async: </div>
            <Switcher
              readOnly={!editable}
              switched={macro && macro.async}
              onChange={(newAsyncVal) => {
                setFunctionPerfValues('async', newAsyncVal);
              }}
            />
          </div>
        : null}

        {showScriptType && (editable || scriptType) ?
          <div className={`${classes.container} ${classes.p5}`}>
            <div className={`${classes.blockName}`}>Script type: </div>
            <input
              readOnly={!editable}
              className={`${classes.input} ${classes.mr5}`}
              value={scriptType || ''}
              onChange={(e) => {
                setFunctionPerfValues('script_type', e.target.value);
              }}
            />
          </div>
        : null}

        {showArgs && (editable || (funcArguments && funcArguments.length)) ?
          <div className={`${classes.container} ${classes.p5}`}>
            <div className={`${classes.blockName}`}>Arguments: </div>

            <div className={`${classes.flex}`} style={{ flexDirection: 'column' }}>
              {funcArguments && funcArguments.length ? (
                funcArguments.map((argument, index) => {
                  return (
                    <div key={index} className={classes.alignCenter} style={{ flexDirection: 'row', marginBottom: '5px' }}>
                      <input
                        className={`${classes.input} ${classes.mr5}`}
                        placeholder={' Name'}
                        value={argument.name || ''}
                        disabled={!editable}
                        onChange={(e) => {
                          addFunctionPerfArguments(index, 'name', e.target.value);
                        }}
                      />

                      <TrplSelect
                        margin="none"
                        addEmptyItem
                        values={macro_types}
                        disabled={!editable}
                        placeholder={"Select type"}
                        onChange={(e) => addFunctionPerfArguments(index, 'type', e.target.value)}
                        value={argument.type}
                      />

                      {argument.type === 'NODE' ?
                        <div className={`${classes.ml5} ${classes.mr5}`}>
                          {argument.concept ? (
                            <Node
                              isLink
                              size="sm"
                              nodeId={argument.concept}
                              node={nodes[argument.concept]}
                              nodes={nodes}
                              isRemovable={editable}
                              onRemoveClick={() => {
                                addFunctionPerfArguments(index, 'concept');
                              }}
                            />
                          ) : (
                            <Search
                              showConcepts
                              conceptsOnly={true}
                              disableTrplEditing={!editable}
                              placeholder="Select concept"
                              inputStyles={{
                                fontSize: '12px',
                                color: '#878787',
                                fontWeight: 'normal',
                              }}
                              containerStyles={{
                                width: '120px',
                                height: '24px',
                                alignSelf: 'center',
                              }}
                              onDropdownElementClick={(props) => {
                                const { node } = props;

                                addNodeToState(node);

                                addFunctionPerfArguments(index, 'concept', props.node.id);
                              }}
                            />
                          )}
                        </div>
                      : null}

                      {editable &&
                        <ClearIcon
                          className={`${classes.ml5}`}
                          onClick={() => onArgRemove(index)}
                        />
                      }
                    </div>
                    )
                  }
                )
              ) : null}

              {editable &&
                <div style={{display: 'flex', flexDirection: 'row'}}>
                  <AddIcon
                    className={`${classes.newArgIcon}`}
                    onClick={() => {
                      addFunctionPerfArguments();
                    }}
                  />
                </div>
              }
            </div>
          </div>
        : null}

        {showReturnType && (editable || returnType) ?
          <div className={`${classes.container} ${classes.p5}`}>
            <div className={`${classes.blockName}`}>Return type: </div>
            <input
              readOnly={!editable}
              value={returnType || ''}
              className={`${classes.input} ${classes.mr5}`}
              onChange={(e) => {
                setFunctionPerfValues('return_type', e.target.value);
              }}
            />
          </div>
        : null}

        {showCode && (editable || functionVal) ?
          <div id="reactAceComponent" className={`${classes.container}`} style={{ height: '100%' }}>
            {!onlyFunction && <div className={`${classes.blockName}`}>Function: </div>}
            <AceEditor
              ref={aceEditorRef}
              editorProps={{
                $maxLines: Infinity,
                $blockScrolling: Infinity,
              }}
              readOnly={!editable}
              fixedWidthGutter={true}
              mode="golang"
              fontSize={12}
              theme="monokai"
              name="code-editor"
              showGutter={true}
              style={{
                resize: nonResizable ? '' : 'both',
                height: nonResizable ? '-webkit-fill-available' : resized ? 'min-height' : linesNumberToPx,
                width: fullWidth ? '-webkit-fill-available' : '500px',
                minWidth: '200px',
                maxWidth: '2000px',
                minHeight: '90px',
                maxHeight: '2000px',
                backgroundColor: (macroEdited && editable) ? '#333757' : '',
                border: borderColor ? `3px solid ${borderColor}` : '',
              }}
              value={functionVal + '' || ''}
              highlightActiveLine={true}
              placeholder="// Start typing code"
              onChange={(value) => {
                setFunctionPerfValues('code', value);
                //if (oldMacro !== undefined) onChangeJsonVal(value);
              }}
              onLoad={editorInstance => {
                //to make editor update on resize
                document.addEventListener("mouseup", e => {
                  return (
                    editorInstance.resize(),
                    setResized(true)
                  )
                });

              }}
              enableLiveAutocompletion={false}
              setAutoScrollEditorIntoView={true}
              setOptions={{
                tabSize: 2,
                wrap: false,
                //minLines: 3,
                //maxLines: Infinity,// to adjust editor's height to fit content
                useWorker: false,
                enableSnippets: true,
                showLineNumbers: true,
                showPrintMargin: false,
                //firstLineNumber: 11,
                hScrollBarAlwaysVisible: true,
                vScrollBarAlwaysVisible: true,
                enableLiveAutocompletion: true,
                enableBasicAutocompletion: true,
                autoScrollEditorIntoView: true,
              }}
            />
          </div>
        : null}
      </div>
    );
};

export default Macros;
